export class UserType {
    static USER = new UserType("user", "Utilisateur")
    static ADMIN = new UserType("admin", "Administrateur")

    value;
    label;

    constructor(value, label) {
        this.value = value;
        this.label = label;
    }

    static values() {
        return [this.USER, this.ADMIN];
    }

    static fromValue(value) {
        for (let userType of UserType.values()) {
            if(userType.value === value) {
                return userType;
            }
        }

        throw new Error("impossiblde de trouver le type d'utilisateur " + value)
    }
}

export const ACL = Object.freeze({
    TERRAINS_LECTURE: "terrains:lecture",
    TERRAINS_ECRITURE: "terrains:ecriture",
    CONTACTS_LECTURE: "contacts:lecture",
    CONTACTS_ECRITURE: "contacts:ecriture",
    UTILISATEURS_LECTURE: "utilisateurs:lecture",
    UTILISATEURS_ECRITURE: "utilisateurs:ecriture",
    ROLES_LECTURE: "roles:lecture",
    ROLES_ECRITURE: "roles:ecriture",
});

export const getUserType = (user) => user?.userType || user?.type || user?.typeUser;

export const getUserTypeLabel = (user) => {
    const userType = getUserType(user);
    return UserType.values().find((type) => type.value === userType)?.label;
};